var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({ref:"input",attrs:{"type":"tel"},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),Object.assign({}, _vm.$listeners,
    {keydown: _vm.handleKeydown,
    paste: _vm.handlePaste,
    input: function (event) { return _vm.handleEmitInput(event.target.value); }})))}
var staticRenderFns = []

export { render, staticRenderFns }